import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHomologousProcedureAvailableCourseById } from 'app/actions/CourseActions';
import { getCourseHomologousProcedureAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseHomologousProcedureAvailableContainer(props){
    let courseHomologousProcedureAvailable = useSelector(getCourseHomologousProcedureAvailable)
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(courseHomologousProcedureAvailable)) fetchCourseClientProcedureAvailableAction();
    }, []);

    const fetchCourseClientProcedureAvailableAction = () => dispatch(fetchHomologousProcedureAvailableCourseById(props.id));
    courseHomologousProcedureAvailable.map(item => item['key'] = item.idProcedure);
    courseHomologousProcedureAvailable.map(item => item['disabled'] = false);
    return (props.children({ courseHomologousProcedureAvailable}));
}